<template>
  <transition name="fade">
    <div class="alert-box" v-show="show">
      <div class="alert-left">
        <i v-if="options.msgIsSuccess" class="icon icon-success"></i>
        <i v-else class="icon icon-error"></i>
      </div>
      <div class="alert-right">
        {{options.msgText}}
      </div>
    </div>
  </transition>
</template>

<script type="text/javascript">
  export default {
    data() {
      return {
        timers: [],
        show: false
      }
    },
    props: {
      options: {
        type: Object,
        default () {
          return {}
        }
      }
    },
    watch: {
      options() {
      
        this.timers.forEach((timer) => {
          window.clearTimeout(timer)
        })
        this.timers = [];
        this.countdown();
      }
    },
    methods: {
      close() {
        this.show = false;
      },
      countdown() {
        this.show = true;
        const t = setTimeout(() => {
          this.close();
        }, 2500)
        this.timers.push(t);
      }
    }
  }
</script>

<style media="screen" lang="scss" scoped>
  .alert-box{
    border-radius: 4px;
    background-color: #fff;
    opacity: 0.98;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    -o-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    padding: 17px 44px 17px 24px;
    z-index: 99999999;
    border: 1px solid #eee;
    box-shadow: 0 0 10px rgba(0, 0, 0, .1);
    padding-left: 80px;
    .alert-left{
      margin-right: 20px;
      width: 40px;
      height: 40px;
      position: absolute;
      left: 20px;
      top: 50%;
      margin-top: -20px;
      .icon{
        width: 40px;
        height: 40px;
        display: inline-block;
        background-size: cover;
        &.icon-success{
          background-image: url(../images/common/succeed.png);
        }
        &.icon-error{
          background-image: url(../images/common/error.png);
        }
      }
    }
    .alert-right{
      float: left;
      color: #4f515e;
      line-height: 40px;
      vertical-align: middle;
      max-width: 400px;
    }
  }
  .fade-enter,.fade-leave-active{
    transition: opacity .5s;
    opacity: 0;
  }
  .fade-enter-active,.fade-leave{
    transition: opacity .5s;
    opacity: .98;
  }
</style>



// WEBPACK FOOTER //
// alert.vue?c4222848